import { api } from "@/shared/libs/axiosClient";
import { CurrentUserResponse, GoogleAuthRequest, GoogleAuthResponse } from "@/shared/types";


/**
 * Google OAuth 토큰으로 백엔드 인증
 * @param request Google OAuth token
 * @returns 백엔드 JWT 토큰과 사용자 정보
 */
export async function loginWithGoogle(
    request: GoogleAuthRequest
): Promise<GoogleAuthResponse> {
    return api.post<GoogleAuthResponse>("/auth/google", request);
}

/**
 * 현재 로그인된 사용자 정보 조회
 * @returns 사용자 정보
 */
export async function getCurrentUser(): Promise<CurrentUserResponse> {
    return api.get<CurrentUserResponse>("/auth/me");
}


export async function logout(): Promise<void> {
    return api.post<void>("/auth/logout");
}

